<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <form
            @submit.prevent="submit(updatedPriceGroup)"
            :class="{ 'disabled-form': disabled }"
          >
            <div class="p-2">
              <div class="mb-3">
                <label class="form-label" for="name">Name</label>
                <input
                  id="name"
                  name="name"
                  placeholder="Enter Price Group Name"
                  type="text"
                  class="form-control"
                  v-model="updatedPriceGroup.name"
                  :disabled="disabled"
                />
              </div>
              <div class="hstack gap-2 mt-4">
                <button v-if="!disabled" type="submit" class="btn btn-primary">
                  Save
                </button>
                <button
                  v-if="disabled"
                  type="button"
                  class="btn btn-primary"
                  @click="edit"
                >
                  Edit
                </button>
                <button type="button" class="btn btn-light" @click="discard">
                  Back
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceGroupForm",
  props: {
    priceGroup: {
      type: Object,
      required: true,
    },
    submitFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      updatedPriceGroup: { ...this.priceGroup },
    };
  },
  methods: {
    submit() {
      if (!this.disabled) {
        delete this.updatedPriceGroup.fullAddress;
        delete this.updatedPriceGroup.priceGroup;
        this.submitFunction(this.updatedPriceGroup);
      }
    },
    discard() {
      this.updatedPriceGroup = { ...this.priceGroup };
      this.$router.push("/priceGroups/");
    },
    edit() {
      this.$router.push("/priceGroups/edit/" + this.priceGroup.id);
    },
  },
  computed: {
    disabled() {
      return typeof this.submitFunction !== "function";
    },
  },
};
</script>

<style scoped>
.disabled-form input {
  pointer-events: none;
  opacity: 0.6;
}
</style>
